const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { CardChangePaymentMethodStep1 } = require('components/cards/cardChangePaymentMethodSteps/cardChangePaymentMethodStep1/cardChangePaymentMethodStep1');
const CardChangePaymentMethodStep2 = require('components/cards/cardChangePaymentMethodSteps/cardChangePaymentMethodStep2/cardChangePaymentMethodStep2');

class CardChangePaymentMethod extends React.Component {
    constructor(props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
    }

    onCancel() {
        const { history, immCard } = this.props;
        const cardId = immCard.get('cardId');

        history.push(`/myprofile/cards/${cardId}/details`);
    }

    render() {
        const {
            immCardChangePaymentMethod,
            validateStep,
            setVisibleStep,
            setWillCancel,
            onFinish,
            immCard,
            immGlobalVariables,
            showIneAndRevolving,
            handleAgreementCheckboxChange,
            isDisabledButton
        } = this.props;

        const immSteps = immCardChangePaymentMethod.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immCardChangePaymentMethod.get('visibleStep');
        const wizardClass = 'card-change-payment-method__wizard';
        const immFinalButton = 'cardChangePaymentMethod-change';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: onFinish,
            cancel: this.onCancel
        };

        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                showPreLeaveModal={!immCard.get('isNerudaCard') && !immCard.get('isVanityCard')}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                    nextButtonDisabled={isDisabledButton}
                >
                    <CardChangePaymentMethodStep1
                        immCard={immCard}
                        immCardChangePaymentMethod={immCardChangePaymentMethod}
                        immGlobalVariables={immGlobalVariables}
                        method={immSteps.get(0).get('method')}
                        installments={immSteps.get(0).get('installments')}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                    isLoading={immCardChangePaymentMethod.get('isFetching')}
                >
                    <CardChangePaymentMethodStep2
                        contractName={immCard.get('contractName')}
                        handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                        immCard={immCard}
                        immCardChangePaymentMethod={immCardChangePaymentMethod}
                        showIneAndRevolving={showIneAndRevolving}
                    />
                </WizardStep>
            </Wizard>
        )
    }
}

CardChangePaymentMethod.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func,
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object,
    immCardChangePaymentMethod: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    showIneAndRevolving: PropTypes.bool.isRequired,
    postChange: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    isDisabledButton: PropTypes.bool,
}

module.exports = withRouter(CardChangePaymentMethod);
